import React, { useEffect, useState } from "react";
/** Component */
import { Paper, Grid, TextField, Autocomplete, Table, TableCell, TableContainer, TableHead, TableBody, TableRow, ButtonGroup, IconButton } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";

/** Icon */
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

/** Hook */
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";

/** API & Funtion */
import { setHeaderTitle } from "../../../store/layoutSlide";
import { getInvoiceForm, replaceERPInvoice, getCustomers } from "../../../services/api";
import { sumOfField, numberToStringVN, convertToMoneyWordEN, round } from "../../../services/libService";

const vat_type = [
  { id: 1, label: "Không chịu thuế", value: -1 },
  { id: 2, label: "Thuế 0%", value: 0 },
  { id: 3, label: "Thuế 5%", value: 5 },
  { id: 3, label: "Thuế 8%", value: 8 },
  { id: 3, label: "Thuế 10%", value: 10 },
];

const ReplaceInvErp = () => {
  /** State */
  const [input, setInput] = useState({
    /** Related invoice */
    e_id: "",
    e_fkey: "",
    serial: "",
    form_no: "",
    date: "",
    customer_address: "",
    customer_name: "",
    customer_tax: "",
    currency: "",
    sub_amount: 0,
    vat: 0,
    vat_rate: 0,
    total: 0,
    valid_date: moment().format("YYYY-MM-DD"),
    inwords: "",
    form: null,
    customer: null,
    note: "",
    invoiceproducts: [],
  });
  /** Hook */
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    /** Init Input and invoiceproducts */
    setInput((prev) => ({
      ...prev,
      /** Related invoice */
      e_id: location.state.id,
      e_fkey: location.state.fkey,
      serial: location.state.seri,
      form_no: location.state.pattern,
      date: location.state.billDate,
      customer_address: location.state.addr,
      customer_name: location.state.customerName,
      customer_tax: location.state.tax,
      currency: location.state.currency,
      sub_amount: location.state.subTotal,
      vat: location.state.VATAtm,
      vat_rate: location.state.VAT,
      total: location.state.invTotal,
      inwords: location.state.inwords,
      note: location.state.remark,
      invoiceproducts: location.state.products.map((item) => ({ productName: item.productName, UoM: item.UoM, invoiceQty: item.invoiceQty, price: item.price, amount: item.amount })),
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleInWords = (currency, amount, type) => {
    if (currency === "VND") {
      return numberToStringVN(amount);
    } else {
      return convertToMoneyWordEN(amount);
    }
  };

  /** Handle line row in products */

  useEffect(() => {
    setInput((prev) => ({ ...prev, sub_amount: sumOfField(prev.invoiceproducts, "amount") }));
  }, [input.invoiceproducts]);

  const handleRemoveProductLine = (id) => {
    setInput((prev) => ({ ...prev, invoiceproducts: prev.invoiceproducts.splice(id) }));
  };

  const handleAddProductLine = (id, item) => {
    setInput((prev) => ({
      ...prev,
      invoiceproducts: [...prev.invoiceproducts, { productName: item.productName, UoM: item.UoM, invoiceQty: item.invoiceQty, price: item.price, amount: item.amount }],
    }));
  };

  /** Handle VAT and VAT Rate */
  useEffect(() => {
    /** If -1 do not need caculate */
    if (input.vat_rate === -1) {
      setInput((prev) => ({
        ...prev,
        total: input.sub_amount,
        inwords: _handleInWords(input.currency, input.sub_amount, input.inv_type),
      }));
    } else {
      setInput((prev) => ({
        ...prev,
        total:
          input.currency === "VND"
            ? parseFloat(input.sub_amount) + round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100)
            : parseFloat(input.sub_amount) + round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100, 2),
        vat: input.currency === "VND" ? round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100) : round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100, 2),
        inwords: _handleInWords(
          input.currency,
          input.currency === "VND"
            ? parseFloat(input.sub_amount) + round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100)
            : parseFloat(input.sub_amount) + round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100, 2),
          input.inv_type
        ),
      }));
    }
  }, [input.currency, input.inv_type, input.sub_amount, input.vat, input.vat_rate]);

  /** Change value in invproduct array */
  const handleChange = (i, name, value) => {
    if (name === "price") {
      setInput((prev) => ({ ...prev, invoiceproducts: prev.invoiceproducts.map((item, id) => (i !== id ? item : { ...item, [name]: value, amount: value * prev.invoiceproducts[i].invoiceQty })) }));
    } else if (name === "invoiceQty") {
      setInput((prev) => ({
        ...prev,
        invoiceproducts: prev.invoiceproducts.map((item, id) => (i !== id ? item : { ...item, [name]: value, amount: value * prev.invoiceproducts[i].price })),
      }));
    } else {
      setInput((prev) => ({
        ...prev,
        invoiceproducts: prev.invoiceproducts.map((item, id) => (i !== id ? item : { ...item, [name]: value })),
      }));
    }
  };

  const handleSubmit = () => {
    return replaceERPInvoice({ ...input, formno: input.form?.form, serial: input.form?.series });
  };

  const handleSubmitResponse = (res) => {
    if (res.code === 200) history.push(`/erpinv`);
  };

  /** Set Page Title */
  useEffect(() => {
    dispatch(setHeaderTitle("PHÁT HÀNH HOÁ ĐƠN THAY THẾ"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Paper styles={{ margin: 10 }}>
      <Grid container spacing={2} sx={{ margin: 3, width: "98%" }}>
        <Grid item xs={3}>
          <FilterBy
            getDataFunc={() => getInvoiceForm({ status: 1 })}
            Autocomplete
            value={input.form}
            getOptionLabel={(option) => `${option.form} - ${option.series}` || ""}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, form: newValue, formno: newValue.form, serial: newValue.series }))}
            label={"Ký hiệu hóa đơn"}
            triggerSetDefaultFunc={Boolean(location.state)}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, form: option.find((item) => item.form === location.state.pattern && item.series === location.state.seri) }))}
          />
        </Grid>
        <Grid item xs={2}>
          <CustomDatePicker
            format="DD/MM/YYYY"
            outputFormat="YYYY-MM-DD"
            label={"Ngày phát hành"}
            value={input.valid_date}
            onChange={(value) => setInput((prev) => ({ ...prev, valid_date: value }))}
            sx={{ width: "100%" }}
          />
        </Grid>

        <Grid item xs={11}>
          <FilterBy
            getDataFunc={() => getCustomers({ status: 1 })}
            Autocomplete
            value={input.customer}
            getOptionLabel={(option) => `${option.code} - ${option.name}` || ""}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, customer: newValue, customer_name: newValue.name, customer_tax: newValue.tax, customer_address: newValue.address }))}
            label={"Đơn vị mua hàng"}
            triggerSetDefaultFunc={Boolean(location.state)}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, customer: option.find((item) => item.code === location.state.customerCode) }))}
          />
          {/* <TextField fullWidth label={"Đơn vị mua hàng"} InputLabelProps={{ shrink: true }} value={input.customer_name} disabled /> */}
        </Grid>
        <Grid item xs={3}>
          <TextField fullWidth label={"Mã số thuế"} InputLabelProps={{ shrink: true }} value={input.customer_tax || ""} disabled />
        </Grid>
        <Grid item xs={8}>
          <TextField fullWidth label={"Địa chỉ"} InputLabelProps={{ shrink: true }} value={input.customer_address || ""} disabled />
        </Grid>
        <Grid item xs={11}>
          <TextField fullWidth label={"Chi chú"} InputLabelProps={{ shrink: true }} value={input.note || ""} onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))} />
        </Grid>
      </Grid>

      <div>
        <div style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", marginTop: 20, textTransform: "uppercase" }}>{"Thông tin hàng hóa"}</div>
        <TableContainer style={{ marginTop: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray", width: "5%" }} align="center"></TableCell>
                <TableCell style={{ border: "0.5px solid lightgray", width: "5%" }} align="center">
                  STT
                </TableCell>
                <TableCell style={{ border: "0.5px solid lightgray", width: "30%" }} align="center">
                  Tên hàng hoá, dịch vụ
                </TableCell>
                <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }} align="center">
                  Đơn vị tính
                </TableCell>
                <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }} align="center">
                  Số lượng
                </TableCell>
                <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }} align="center">
                  Tiền tệ
                </TableCell>
                <TableCell style={{ border: "0.5px solid lightgray", width: "15%" }} align="center">
                  Đơn giá
                </TableCell>
                <TableCell style={{ border: "0.5px solid lightgray", width: "15%" }} align="center">
                  Thành tiền
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {input?.invoiceproducts?.map((item, id) => (
                <TableRow key={id}>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "5%" }}>
                    {id === 0 ? (
                      <IconButton color="primary" onClick={() => handleAddProductLine(id, item)}>
                        <AddCircleIcon />
                      </IconButton>
                    ) : (
                      <IconButton color="error" onClick={() => handleRemoveProductLine(id)}>
                        <RemoveCircleIcon />
                      </IconButton>
                    )}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "5%" }}>{id + 1}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "30%" }}>
                    <TextField fullWidth value={item.productName || ""} onChange={(e) => handleChange(id, "productName", e.target.value)} />
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }}>
                    <TextField fullWidth value={item.UoM || ""} inputProps={{ style: { textAlign: "center" } }} onChange={(e) => handleChange(id, "UoM", e.target.value)} />
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }}>
                    <TextField fullWidth inputProps={{ style: { textAlign: "right" } }} value={item.invoiceQty || ""} onChange={(e) => handleChange(id, "invoiceQty", e.target.value)} />
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }}>
                    <TextField disabled inputProps={{ style: { textAlign: "center" } }} fullWidth value={input.currency || ""} />
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "15%" }}>
                    <TextField fullWidth inputProps={{ style: { textAlign: "right" } }} value={item.price || ""} onChange={(e) => handleChange(id, "price", e.target.value)} />
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "15%", textAlign: "right" }}>
                    {input.currency === "VND"
                      ? Math.round(item.amount || 0).toLocaleString("vi-VN")
                      : (item.amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer style={{ marginTop: 2, width: "100%" }}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell style={{ width: "20%" }} align="left">
                  Cộng tiền hàng
                </TableCell>
                <TableCell style={{ width: "20%" }} align="left" />
                <TableCell style={{ width: "10%" }} align="left">
                  {input.currency}
                </TableCell>
                <TableCell style={{ width: "30%" }} align="right">
                  {input.currency === "VND"
                    ? Math.round(input.sub_amount || 0).toLocaleString("vi-VN")
                    : (input.sub_amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ width: "20%" }} align="left">
                  Thuế suất GTGT
                </TableCell>
                <TableCell style={{ width: "30%" }} align="center">
                  <Autocomplete
                    disableClearable
                    options={vat_type}
                    getOptionLabel={(option) => option.label}
                    value={vat_type.find((item) => item.value === input.vat_rate) || vat_type[0]}
                    onChange={(e, newValue) =>
                      setInput((prev) => ({
                        ...prev,
                        vat_rate: newValue.value,
                        vat: newValue.value !== -1 ? (prev.sub_amount === 0 ? prev.sub_amount : (prev.sub_amount * newValue.value) / 100) : -1,
                      }))
                    }
                    renderInput={(params) => <TextField {...params} />}
                  />
                </TableCell>
                <TableCell style={{ width: "10%" }} align="left">
                  {input.currency}
                </TableCell>
                <TableCell style={{ width: "30%" }} align="right">
                  {input.vat === -1
                    ? "\\"
                    : input.currency === "VND"
                    ? Math.round(input.vat || 0).toLocaleString("vi-VN")
                    : (input.vat || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ width: "20%" }} align="left">
                  Tổng tiền hàng
                </TableCell>
                <TableCell style={{ width: "20%" }} align="left" />
                <TableCell style={{ width: "10%" }} align="left">
                  {input.currency}
                </TableCell>
                <TableCell style={{ width: "30%" }} align="right">
                  {input.currency === "VND" ? Math.round(input.total || 0).toLocaleString("vi-VN") : (input.total || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={4} align="left">
                  Số tiền viết bằng chữ: {input.inwords}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <div align="left">
        {/* button is disabled if required field is empty */}
        <ButtonGroup style={{ margin: 5 }}>
          <ButtonWithAPICall style={{ margin: 2 }} variant="contained" api={handleSubmit} response={handleSubmitResponse}>
            {"Phát hành"}
          </ButtonWithAPICall>
        </ButtonGroup>
      </div>
    </Paper>
  );
};

export default ReplaceInvErp;
